/**
 * Collapses the feature cards on phones.
 *
 * The markup ships with `open` set, so with no JavaScript every card reads in
 * full — the copy is never trapped behind an interaction that failed to load.
 * This closes them below the breakpoint and reopens them above it.
 */
(() => {
  const QUERY = window.matchMedia('(max-width: 749px)');
  const cards = [...document.querySelectorAll('details.ms-feature-card')];
  if (!cards.length) return;

  const apply = () => {
    // Leave a card the reader has opened alone; only sync the ones untouched.
    cards.forEach((card) => {
      if (card.dataset.msTouched) return;
      card.open = !QUERY.matches;
    });
  };

  cards.forEach((card) => {
    card.addEventListener('toggle', () => {
      if (QUERY.matches) card.dataset.msTouched = '';
    });
  });

  apply();
  QUERY.addEventListener('change', () => {
    cards.forEach((card) => delete card.dataset.msTouched);
    apply();
  });
})();
